import React from 'react';
import './contact.css';

const decode = (str) => {
  let newString = "";
  for (let i = 0; i < str.length; i++) {
    const newNumber = (str.charCodeAt(i) + 2);
    let newLetter;
    if (newNumber > 122) {
      newLetter = String.fromCharCode(96 + (newNumber % 122));
    } else {
      newLetter = String.fromCharCode(newNumber);
    }
    newString += newLetter;
  }
  return newString;
};

const Contact = () => {
  return (
    <div className="contact-main">
      <p>
      I would love to hear from you regarding my projects,
      any projects you'd like to collaborate on,
      or other opportunities. Thanks for being in touch!
      </p>
      <span className="email"><a href={`mailto:${decode("yqaflcgr")}@gmail.com`}>aschneit [at] gmail [dot] com</a></span>
    </div>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx